<template>
  <div class="mainContainer">
    <div class="nav">
      <el-form  :inline="true" :model="searchForm">
        <el-form-item label="委托单位:" >
          <el-input v-model="searchForm.consignorName" size='mini' placeholder="请输入委托单位"/>
        </el-form-item>
        <el-form-item label="类别:" >
            <el-input v-model="searchForm.type" size='mini' placeholder="请输入类别"/>
        </el-form-item>
        <el-form-item label="水运起运日期：" prop="startDate">
          <el-date-picker
            v-model="searchForm.loadingDate"
            size="mini"
            type="date"
            style='width:170px'
            value-format="yyyy-MM-dd"
            placeholder="请选择水运起运日期" />
        </el-form-item>
        <el-form-item label="水运完成日期：" prop="endDate">
          <el-date-picker
            v-model="searchForm.deliveryDate"
            size="mini"
            type="date"
            style='width:170px'
            value-format="yyyy-MM-dd"
            placeholder="请选择水运完成日期"/>
        </el-form-item>
        <el-form-item label='交车日期：'>
          <el-date-picker v-model="searchForm.deliverStartTime" size="mini" style="width: 150px"
                          value-format="yyyy-MM-dd" @change="dateChange2" type="date" placeholder="开始日期" />
          <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
          <el-date-picker v-model="searchForm.deliverEndTime" size="mini" style="width: 150px"
                          value-format="yyyy-MM-dd" @change="dateChange2" type="date" placeholder="结束日期" />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
   <el-row>
    <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
       <span @click='exportDetailsAll'>详情批量导出</span>
       <span @click='exportData'>导出数据</span>
     </el-col>
   </el-row>
    <div class="content">
        <el-table
          v-loading = "tableLoading"
          :data="tableData"
          border
          style="width: 100%"
          :header-cell-style='headerCellStyle'
          @selection-change='selectionDataChange'
          :row-style="rowStyle"
        >
          <el-table-column type="selection" align="center" width="50" />
          <el-table-column align="center" prop="consignorName" label="委托单位" show-overflow-tooltip/>
          <el-table-column align="center" prop="brandName" label="品牌" />
          <el-table-column align="center" prop="type" label="类别" />
          <el-table-column align="center" prop="zyl" label="总运量" />
          <el-table-column align="center" prop="msCount" label="民生运量（全程）" />
          <el-table-column align="center" prop="fmsCount" label="非民生运量（全程）" />
          <el-table-column align="center" prop="zzCount" label="民生与非民生中转运量" />
          <el-table-column label="操作" width="150" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size='small' class='searchBtn' type="primary" @click='detailClick(scope.row)'>详情</el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <div class='paginationContainer'>
      <el-pagination
        background
        :page-sizes='[10, 20, 30, 40]'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'
        @size-change='contractSizeChange'
        @current-change='contractCurrentChange'
        :current-page.sync='searchForm.page'
        :page-size='searchForm.rows'
      />
    </div>
    <detailsPickupTruck ref="detailsPickupTruckRef"/>
  </div>
</template>

<script>
import {addList, getListPage} from "@/service/vehiclelog";
import detailsPickupTruck from './components/detailsPickupTruck.vue'
import {getSessionStore} from "@/config/mUtils";
import {baseUrl} from "@/config/env";

export default {
  name: "index.vue",
  components: {detailsPickupTruck},
  data() {
    return {
      searchForm: {
        consignorName: '',
        type: '',
        loadingDate: '',
        deliveryDate: '',
        deliverStartTime: '',
        deliverEndTime: '',
        page: 1,
        rows: 10,
      },
      total: 0,
      tableData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      tableLoading: false,
      selectedData: [],
    }
  },
  mounted() {
    this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm))
  },
  methods:{
    // 查询
    searchBtn() {
      this.searchForm.page = 1
      this.getTableData()
    },
    // 重置
    resetBtn() {
      this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm))
    },
    // 获取表格数据
    async getTableData() {
      this.tableLoading = true
      const {
        status,
        message,
        data,
      } = await getListPage(this.searchForm)
      this.tableLoading = false
      if (status !== 0) return this.$message.warning(message)
      this.tableData = data.records
      this.total = data.total
    },
    //详情
    detailClick(row){
      let loadingDate = this.searchForm.loadingDate
      let deliveryDate = this.searchForm.deliveryDate
      let deliverStartTime = this.searchForm.deliverStartTime
      let deliverEndTime = this.searchForm.deliverEndTime
      this.$refs.detailsPickupTruckRef.dialogOpen('详情',row,deliverStartTime,deliverEndTime,loadingDate,deliveryDate)
    },
    //导出数据
    exportDetailsAll() {
      
      // window.exportExcelAll('post', '/sporadicVehicleStatisticsReport/exportBatch', {...this.searchForm}, '零星车详情统计表.xls');
      // console.log(this.selectedData);
      // console.log(this.searchForm);
      
      if (this.selectedData.length > 0) {
        const msg = this.$message({
          message: "导出中请勿操作......",
          iconClass: 'el-icon-loading',
          duration: 0,
        });
        let arr = [];
        this.selectedData.forEach(element => {
          arr.push({
            brandName: element.brandName,
            consignorName: element.consignorName,
            deliverEndTime: this.searchForm.deliverEndTime,
            deliverStartTime: this.searchForm.deliverStartTime,
            deliveryDate: this.searchForm.deliveryDate,
            loadingDate: this.searchForm.loadingDate,
            type: element.type,
          })
        });
        // msg.close();
        window.exportExcelAllFunc({
          type: 'post',
          url: '/sporadicVehicleStatisticsReport/exportBatch',
          obj: arr,
          name: '零星车详情统计表.xls',
          func: () => {
            msg.close();
          }
        })
      } else {
        this.$message.warning("请先选择零星车！");
      }
      
    },
    exportData(){
      let token = getSessionStore('token');
      const exportParams = {
        voyageNumber: '',
        supplierName: '',
        batchNumber: '',
        waybillNo: '',
        frameNumber: '',
        brandName: '',
        state: '',
        shipName: '',
        startPlanDate: '',
        endPlanDate: '',
        startLoadingDate: '',
        endLoadingDate: '',
        consignorName: this.searchForm.consignorName,
        type: this.searchForm.type,
        loadingDate: this.searchForm.loadingDate,
        deliveryDate: this.searchForm.deliveryDate,
        deliverStartTime: this.searchForm.deliverStartTime ? this.searchForm.deliverStartTime : '', //交车日期开始时间
        deliverEndTime:this.searchForm.deliverEndTime ? this.searchForm.deliverEndTime : '', //交车日期结束时间
      };
      window.exportExcel(`${baseUrl}/platform/sporadicVehicleStatisticsReport/export?access_token=${token}`, exportParams, '零星车统计报表');
    },
    selectionDataChange(selection) {
      this.selectedData = selection;
    },
    rowStyle({ row }) {
      return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    contractSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableData();
    },
    contractCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableData();
    },
    // 交车开始-结束日期验证
    dateChange2(val) {
      if (this.searchForm.deliverEndTime && this.searchForm.deliverStartTime && (this.searchForm.deliverEndTime <= this.searchForm.deliverStartTime)) {
        if (val == this.searchForm.deliverEndTime) this.searchForm.deliverEndTime = '';
        if (val == this.searchForm.deliverStartTime) this.searchForm.deliverStartTime = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
  }
}
</script>

<style scoped>
.mainContainer{
  width: 100%;
  padding: 20px 15px 0 15px;
  background-color: #fff;

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }

  .content {
    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-top: 10px;

      span {
        font-size: 13px;
      }
    }
  }
}

</style>
